export const MainRoutesPaths = {
  main: '/',
  clients: '/clients/',
  schedule: `/schedule/`,
  events: `/events/`,
  articles: `/articles/`,
  // scheduleService:'/scheduleService/',
} as const;
